import {
  Component,
  Input,
  OnInit,
  OnDestroy
} from "@angular/core";

@Component({
  selector: "app-my-regular-saving-plan",
  templateUrl: "./my-regular-saving-plan.component.html",
  styleUrls: ["./my-regular-saving-plan.component.css"]
})
export class MyRegularSavingPlanComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Input() isShowSlider: boolean;
  ngOnInit() {}

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/features/my-financial/my-regular-saving-plan/my-regular-saving-plan.component.ts